
<template>
    
        <mars-view v-if="!isLogin && (platform !== 'web' || isUseInH5 || isSwan)"><template v-if="canBubble"><mars-view class="c-login-button"><mars-button class="c-reset-swan-button" open-type="login" type="button" @login="loginBtnCallBackHandle" @click.native="loginBtnClickHandle"><template v-if="userName"><mars-view :class="className">{{ userName }}</mars-view><mars-view v-if="hideArrow" class="user-name-arrow iconfont yj-iconright"></mars-view></template><mars-image v-if="userImageSrc" :class="className" :src="userImageSrc"></mars-image></mars-button></mars-view></template><template v-else><mars-view class="c-login-button" @click.native.stop><mars-button class="c-reset-swan-button" open-type="login" type="button" @login="loginBtnCallBackHandle" @click.native="loginBtnClickHandle"><template v-if="userName"><mars-view :class="className">{{ userName }}</mars-view><mars-view v-if="hideArrow" class="user-name-arrow iconfont yj-iconright"></mars-view></template><mars-image v-if="userImageSrc" :class="className" :src="userImageSrc"></mars-image></mars-button></mars-view></template></mars-view>
    
</template>

<script>
/**
 * @file 登录按钮
 * @author lixueyang01
 */
/* globals getApp swan */
import log from '../../static/utils/ubcLog';
import { toLoginPage } from '../../static/utils/login.js';
export default {
  props: {
    className: {
      'type': String,
      'default': ''
    },
    userName: {
      'type': String,
      'default': ''
    },
    hideArrow: {
      'type': Boolean,
      'default': true
    },
    userImageSrc: {
      'type': String,
      'default': ''
    },
    loginedCanClick: {
      'type': Boolean,
      'default': false
    },
    pageListData: {
      'type': Object,
      'default': null
    },
    // 登录成功后跳转地址
    href: {
      'type': String,
      'default': ''
    },
    // 点击事件是否冒泡
    canBubble: {
      'type': Boolean,
      'default': false
    },
    // h5是否使用该组件判断登录
    isUseInH5: {
      'type': Boolean,
      'default': true
    }
  },
  data() {
    return {
      isSwan: "h5" === 'swan',
      platform: getApp().globalData.platform,
      isLogin: getApp().globalData.userInfo.is_login
    };
  },
  options: {
    addGlobalClass: true
  },
  components: {},
  methods: {
    loginBtnCallBackHandle(e) {
      if (e.detail.errMsg === 'login:ok') {
        // 登录成功打点
        log.send({
          serverId: 16197,
          action: 'click',
          area: 'login-succ'
        });
        // 登录后更新全局登录状态信息
        getApp().globalData.userInfo.is_login = 1;
        if (this.pageListData) {
          this.$emit('callBackSucc', this.pageListData);
        } else {
          this.$emit('callBackSucc');
        }
      } else {
        // 登录失败打点
        log.send({
          serverId: 16197,
          action: 'click',
          area: 'login-fail'
        });
        this.$emit('callBackError');
      }
    },
    loginBtnClickHandle() {
      // 登录点击打点
      log.send({
        serverId: 16197,
        action: 'show',
        area: 'login-card'
      });
      this.$emit('loginBtnClickHandle');
      // h5未登录
      if (this.platform === 'web' && this.isUseInH5 && !this.isLogin) {
        toLoginPage({
          href: this.href
        });
      }
    }
  },
  beforeMount() {
    (function () {}).call(this, this.$route.query);
  },
  activated() {
    (function () {
      setTimeout(() => {
        this.isLogin = this.platform !== 'web' ? this.$api.isLoginSync().isLogin : getApp().globalData.userInfo.is_login;
      }, 1000);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.c-login-button {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  left: 0;
}
.c-login-button .c-reset-swan-button {
  width: 100%;
  height: 100%;
}

</style>
